var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2736 3.31517C41.957 2.63176 43.065 2.63176 43.7485 3.31517L53.648 13.2146C53.9762 13.5428 54.1605 13.988 54.1605 14.4521C54.1605 14.9162 53.9762 15.3613 53.648 15.6895L17.3498 51.9877C17.0216 52.3159 16.5765 52.5002 16.1124 52.5002L6.21315 52.5C5.24669 52.5 4.46322 51.7165 4.46319 50.7501L4.46289 40.8508C4.46288 40.3866 4.64725 39.9415 4.97545 39.6133L41.2736 3.31517ZM42.511 7.02748L7.96291 41.5756L7.96314 49L15.3875 49.0002L49.9357 14.4521L42.511 7.02748Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3736 13.2145C32.057 12.531 33.165 12.531 33.8484 13.2145L43.748 23.114C44.4314 23.7974 44.4314 24.9054 43.748 25.5889C43.0645 26.2723 41.9565 26.2723 41.2731 25.5889L31.3736 15.6893C30.6902 15.0059 30.6902 13.8979 31.3736 13.2145Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.0ce92798.svg";
export { ForwardRef as ReactComponent };